import React, { useState } from "react";
import { FileBarChart, Mail, Loader2, Download } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError, openPdf } from "@/lib/api";
import { Card } from "@/components/Cards";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const prevMonth = () => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 1); return d.toISOString().slice(0, 7); };

export default function MonthlyReportCard() {
  const [month, setMonth] = useState(prevMonth());
  const [busy, setBusy] = useState("");

  const download = async () => {
    setBusy("pdf");
    try {
      const res = await api.get("/reports/monthly", { params: { month, format: "pdf" }, responseType: "blob" });
      openPdf(res.data);
      toast.success("Aylık rapor açıldı");
    } catch { toast.error("Rapor oluşturulamadı"); } finally { setBusy(""); }
  };
  const send = async () => {
    setBusy("mail");
    try { const { data } = await api.post("/reports/monthly/send", null, { params: { month } }); toast.success(data.message); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(""); }
  };

  return (
    <Card className="p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="monthly-report-card">
      <div className="flex items-center gap-2 text-sm font-medium"><FileBarChart className="h-4 w-4 text-primary" /> Aylık Yönetici Raporu</div>
      <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-10 w-[170px] font-mono" data-testid="monthly-report-month" />
      <Button variant="outline" onClick={download} disabled={!!busy} className="h-10 gap-2" data-testid="monthly-report-download">{busy === "pdf" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} PDF Görüntüle</Button>
      <Button onClick={send} disabled={!!busy} className="h-10 gap-2" data-testid="monthly-report-send">{busy === "mail" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} Yöneticilere E-postala</Button>
      <span className="text-xs text-muted-foreground">Her ayın 1'i 07:00'da önceki ayın raporu otomatik gönderilir.</span>
    </Card>
  );
}
